import React from 'react';
import languageService from 'services/languageService';

const Languages = (props) => (
    <div className="language-tooltip__content">
        {
            props.languageList.map((language,idx) => (
                <React.Fragment key={`${language.LANGUAGE_ID}-lang-option`}>
                    <div onClick={() => languageService.changeLanguage(language)}>
                        {language.LANGUAGE_NAME}
                    </div>
                    {
                        idx != props.languageList.length -1 ?
                            <hr/>
                        :
                            null
                    }
                </React.Fragment>
            ))
        }
    </div>
)
export default Languages;